const WSState = {
  LOGGED: 'logged',
  CLOSE: 'close',
  FAILED_LOGIN: 'failed-login',
  CONNECT: 'connect',
};

module.exports = WSState;
